import { InjectionToken } from '@angular/core';

import { environment } from '@env/environment';
import type { Environment } from '../../../environments/environment.model';

/**
 * Application configuration.
 *
 * Everything that varies per deployment target is read through this token
 * rather than by importing `environment` directly. That keeps components and
 * services testable (override the token) and keeps the number of modules that
 * know about build-time file replacement down to one.
 */
export type AppConfig = Environment;

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG', {
  providedIn: 'root',
  factory: () => environment,
});
